import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/reddit-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M283.2 345.5C285.9 348.2 285.9 352.3 283.2 354.7 258.7 379.2 189.4 379.3 164.8 354.7 162.1 352.3 162.1 348.2 164.8 345.5 167.2 343.1 171.3 343.1 173.7 345.5 192.4 364.7 254.7 365.1 274.2 345.5 276.6 343.2 280.8 343.2 283.2 345.5zM191.9 291.7C191.9 276.8 180 264.9 165.4 264.9 150.5 264.9 138.6 276.8 138.6 291.7 138.6 306.3 150.5 318.2 165.4 318.2 180 318.2 191.9 306.3 191.9 291.7zM282.6 264.9C268 264.9 256.1 276.8 256.1 291.7 256.1 306.3 268 318.2 282.6 318.2 297.5 318.2 309.4 306.3 309.4 291.7 309.4 276.8 297.5 264.9 282.6 264.9zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM348.3 220.6C338.2 220.6 329.3 224.8 322.7 231.3 298.6 214.6 266.2 203.9 230.2 202.7L248.9 118.5 308.4 131.9C308.4 146.5 320.3 158.4 334.9 158.4 349.8 158.4 361.7 146.2 361.7 131.6 361.7 117 349.8 104.8 334.9 104.8 324.5 104.8 315.6 111 311.1 119.7L245.4 105.1C242.1 104.2 238.9 106.6 238 109.9L217.5 202.7C181.8 204.2 149.7 214.9 125.6 231.6 119.1 224.8 109.8 220.6 99.7 220.6 62.2 220.6 49.9 271 84.2 288.1 83 293.5 82.4 299.1 82.4 304.8 82.4 361.3 146.1 407.1 224.3 407.1 302.8 407.1 366.5 361.3 366.5 304.8 366.5 299.1 365.9 293.2 364.4 287.8 398 270.6 385.6 220.6 348.3 220.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/reddit-square.js
// module id = ztfp
// module chunks = 144